import MockAdapter from 'axios-mock-adapter'
import { MockEndpointConfig, MockHandler } from './types'

/**
 * Utility function to mock a dynamic endpoint with axios-mock-adapter.
 *
 * @param mock - Instance of MockAdapter
 * @param config - Configuration for the endpoint (method and path)
 * @param handler - Function to handle the mock response
 * @param options - Optional configuration (e.g., delayResponse)
 */
export const mockDynamicEndpoint = (
    mock: MockAdapter,
    config: MockEndpointConfig,
    handler: MockHandler
): void => {
    const { method, path } = config
    let pathRegex

    // Special case for the conflict between reports/:reportId and specific report types
    if (path === '/api/v1/customers/:customerId/reports/:reportId') {
        // Create a pattern that excludes specific report types
        pathRegex =
            /^\/api\/v1\/customers\/[^/]+\/reports\/(?!usage-cost|payables-summary)[^/]+$/
    } else {
        // Standard behavior for all other paths
        pathRegex = new RegExp(`^${path.replace(/:([a-zA-Z]+)/g, '[^/]+')}$`)
    }

    switch (method) {
        case 'get':
            mock.onGet(pathRegex).reply(handler)
            break
        case 'post':
            mock.onPost(pathRegex).reply(handler)
            break
        case 'put':
            mock.onPut(pathRegex).reply(handler)
            break
        case 'patch':
            mock.onPatch(pathRegex).reply(handler)
            break
        case 'delete':
            mock.onDelete(pathRegex).reply(handler)
            break
        default:
            throw new Error(`Unsupported HTTP method: ${method as string}`)
    }
}
